import React from 'react';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { AccountACHTransferAccountSummaryCard } from 'src/Components/Accounts/AccountACHTransferSummary';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import MetaControlField from 'src/Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'src/Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';


const ScheduledCashJournalSetupStepContent = () => {
  const { pageContentResource: resource } = usePageContentContext();

  const fromAccount = {
    title: resource.attr('sourceAccountName'),
    image: resource.attr('image'),
    subtitle: resource.attr('sourceMaskedAccountNumber'),
    balance: resource.attr('sourceAccountBalance'),
  };
  const toAccount = {
    title: resource.attr('destinationAccountName'),
    image: resource.attr('image'),
    subtitle: resource.attr('destinationMaskedAccountNumber'),
    balance: resource.attr('destinationAccountBalance'),
  };

  return (
    <PageContentContainer>
      <PageContentTop
        resource={resource}
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />

      <FDStack direction="column" spacing={3}>
        <AccountACHTransferAccountSummaryCard isWithdrawal={false} fromAccount={fromAccount} toAccount={toAccount} />
        <FDStack direction="column" spacing={1}>
          <FDStack direction="column" spacing={1}>
            <FDBodyText size="md" value="Transfer Details" />
            <MetaControlField attr="fullLiquidation" />
            <MetaControlField attr="amount" />
            <MetaControlField attr="frequency" />
            <MetaControlField attr="startDate" />
            <MetaControlField attr="endByDate" />
            <MetaControlField attr="iraDistributionReason" />
            <MetaControlField attr="iraContributionType" />
            <MetaControlField attr="iraContributionApplyToPriorYear" />
            <MetaLayoutRemainingFields noAccordion />
          </FDStack>
          <FDStack direction="column">
            <MetaControlField attr="taxDetailsLabel" />
            <MetaControlField attr="acknowledgementOfTaxInformation" />
            <MetaControlField attr="withholdFederalTaxes" />
            <MetaControlField attr="federalTaxWithholdingPercentage" />
            <MetaControlField attr="withholdStateTaxes" />
            <MetaControlField attr="stateTaxWithholdingPercentage" />
          </FDStack>
          <MetaControlField attr="disclaimer" />
        </FDStack>
      </FDStack>

    </PageContentContainer>
  );
};

export { ScheduledCashJournalSetupStepContent };
